import React, { useEffect, useState } from "react";
import HelpPanel from "@cloudscape-design/components/help-panel";

import VariationsTable from "./components/vehicle-table";

import {
  AppLayout,
  BreadcrumbGroup,
  Icon,
  ContentLayout,
  Header,
  SplitPanel,
  Link,
  Box,
  Spinner,
} from "@cloudscape-design/components";

import { Navigation } from "../../../components/app/Navigation";
import { VehicleMasterTable } from "./data";
import { generateClient } from "aws-amplify/api";
import { listVehicles } from "../../../graphql/queries";
import { ListVehiclesQueryVariables } from "../../../API";
import { fetchAuthSession } from "aws-amplify/auth";

export default function WVehicles() {
  const [activeHref, setActiveHref] = React.useState("/vehicles");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [vehicleList, setVehicleList] = useState<VehicleMasterTable[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    fetchVehicle();
  }, []);

  async function fetchVehicle(limit = 100) {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allVehicles: VehicleMasterTable[] = [];

      do {
        const variables: ListVehiclesQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listVehicles,
          authMode: "userPool",
          variables,
        });

        const vehicles = response.data.listVehicles.items;
        nextToken = response.data.listVehicles.nextToken ?? null; // Ensure nextToken is either string or null

        const newVehicles: VehicleMasterTable[] = vehicles.map(
          (vehicle: any) => {
            const formattedTimestamp = new Date(
              vehicle.updatedAt
            ).toLocaleString();
            return {
              id: vehicle.id,
              VehicleCode: vehicle.vehiclecode ?? "",
              TypeVehicle: vehicle.typevehicle ?? "",
              Location: vehicle.location ?? "",
              Category: vehicle.category ?? "", // Ensure Category is included
              Status: Boolean(vehicle.status),
              Timestamps: formattedTimestamp ?? "",
            };
          }
        );

        allVehicles = [...allVehicles, ...newVehicles];
      } while (nextToken);

      setVehicleList(allVehicles);
      setIsLoading(false);
    } catch (err) {
      console.log("error fetching vehicles: ", err);
    }
  }

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicle",
              },
              {
                text: "Vehicle Summary",
                href: "/vehicles",
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }}
          />
        }
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/vehicles" ? `Vehicles Summary ` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder' style={{marginTop: isLoading ? '160px' : '0px'}}>
              {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading vehicle data...</Box>
                </Box>
              ) : (
                <VariationsTable
                  VehicleMaster={vehicleList}
                  refreshData={fetchVehicle}
                />
              )}
              {/* <VariationsTable VehicleMaster={vehicleList} refreshData={fetchVehicle} /> */}
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}
